import React from 'react'

import NewManagerAccountsList from './NewManagerAccountsList'

export default class NewManagerAccountsWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        return (
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title">New Manager Accounts</h4>
                        <p class="category">See a snapshot of the latest user signups</p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                                <NewManagerAccountsList />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Admin/Users/NewManagerAccountsWidget.jsx